export { default as BackgroundCircle } from './BackgroundCircle';
export type { BackgroundCircleProps } from './BackgroundCircle';
